import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IUser {
    accessToken: string;
    beta: boolean;
    email: string;
    firstName: string;
    id: number;
    premium: boolean;
}
export const InitUser: IUser = {
    accessToken: "",
    beta: false,
    email: "",
    firstName: "",
    id: 0,
    premium: false,
}

interface IWebpageState {
    selectedMenu: string;
    isLoggedIn: boolean;
    user: IUser;
}

const initialState: IWebpageState = {
    selectedMenu: "",
    isLoggedIn: false,
    user: InitUser,
};

const webpageSlice = createSlice({
    name: 'counter',
    initialState,
    reducers: {
        updateSelectedMenu: (state, action: PayloadAction<string>) => {
            state.selectedMenu = action.payload;
        },
        setIsLoggedIn: (state, action: PayloadAction<boolean>) => {
            state.isLoggedIn = action.payload;
        },
        setUser: (state, action: PayloadAction<IUser>) => {
            state.user = action.payload;
        },
    },
});

export const { updateSelectedMenu, setIsLoggedIn, setUser } = webpageSlice.actions;
export default webpageSlice.reducer;
